import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Photoshop = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  return (
    <div>
   <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">What will I learn in this course?</h1>
          <ul>
            <li>Introduction</li>
            <li>Getting to know the work area</li>
            <li>Working with selections</li>
            <li>Layer Basics</li>
            <li>Masks and Channels</li>
            <li>Typographic Design</li>
          </ul>
          <p><b>Session 1: Introduction</b></p>
          <p>Raster vs. Vector,Creating new images,Saving files for print,Saving files for web/screen,Working with Adobe Bridge</p>
          <p><b>Session 2: Getting to Know the Work Area</b></p>
          <p>Using the tools U,sing the options bar and other panels,Undoing actions in Photoshop,Customizing the workspace,Tools panel overview</p>
          <p><b>Session 3: Working with Selections</b></p>
          <p>Using the Quick Selection tool,Moving a selected area,Manipulating selections,Using the Magic Wand tool,Selecting with the lasso tools,Rotating a selection,Selecting with the Magnetic Lasso tool,Cropping an image and erasing within a selection,Refining the edge of a selection</p>
          <p><b>Session 4: Layer Basics</b></p>
          <p>About layers,Using the Layers panel,Rearranging layers,Applying a gradient to a layer,Applying a layer style,Flattening and saving files</p>
          <p><b>Session 5: Masks and Channels</b></p>
          <p>Working with masks and channels,Creating a mask,Refining a mask,Creating a quick mask,Manipulating an image with Puppet Warp,Working with channels</p>
          <p><b>Session 6: Typographic Design</b></p>
          <p>About type,Creating a clipping mask from type,Creating type on a path,Warping point type,Designing paragraphs of type</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
        {/* Search Form Start */}
        <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Photoshop